module.exports = __webpack_public_path__ + "img/com.aeg.airconditioner.02a000f5.webp";